import { render, staticRenderFns } from "./HollandTest.vue?vue&type=template&id=05da1e2a&scoped=true"
import script from "./HollandTest.vue?vue&type=script&lang=js"
export * from "./HollandTest.vue?vue&type=script&lang=js"
import style0 from "./HollandTest.vue?vue&type=style&index=0&id=05da1e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da1e2a",
  null
  
)

export default component.exports